import { IOrder } from "./order";

export interface ICall {
  id: string;
  startedAt: string;
  timestamp: string;
  phone: string;
  customerName?: string;
  duration: string;
  summary: string;
  audioUrl: string;
  didError: boolean;
  didTransfer: boolean;
  payments: Payment[];
  sentiment: ISentiment | undefined;
  order?: IOrder | undefined;
  orderEntryStatus?: IOrderEntryStatus;
}

export const PaymentStatus = {
  AUTHORIZED: "AUTHORIZED", // Payment has been successfully authorized but not yet captured
  SUCCEEDED: "SUCCEEDED", // Payment was successful
  CANCELLED: "CANCELLED", // Payment authorization has been cancelled
  REFUNDED: "REFUNDED", // Payment has been refunded
  FAILED: "FAILED", // Payment failed, during either authorization or capture
} as const;
export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export interface Payment {
  amount: number;
  status: PaymentStatus;
  createdAt: string;
}

export type IOrderEntryStatus =
  | "SKIPPED"
  | "PROCESSING"
  | "SUBMITTED"
  | "UNKNOWN";

export type ISentiment = "negative" | "positive" | "neutral" | "unknown";

export interface IReportCallData {
  topic: string;
  description?: string;
}
